import { makeStyles } from 'tss-react/mui';

const CARD_HEIGHT = 56;

const CARD_PADDING = 0.5;

const CONTENT_MAX_WIDTH = 160;

export const useRachelAttachmentCardStyles = makeStyles()((theme) => ({
  card: {
    display: 'flex',
    alignItems: 'flex-start',
    flex: 'none',
    gap: theme.spacing(1),
    boxSizing: 'border-box',
    height: CARD_HEIGHT,
    padding: theme.spacing(CARD_PADDING),
    borderRadius: theme.shape.borderRadiusLg,
    border: `0.5px solid ${theme.palette.custom.border.primary}`,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    overflow: 'hidden',
  },
  info: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    height: '100%',
    minWidth: 0,
  },
  badge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 'none',
    height: '100%',
    aspectRatio: '1 / 1',
    borderRadius: theme.shape.borderRadiusSm,
    backgroundColor: theme.palette.action.selected,
    color: theme.palette.accent.light,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(0.25),
    minWidth: 0,
    maxWidth: CONTENT_MAX_WIDTH,
  },
  nameRow: {
    display: 'flex',
    alignItems: 'flex-start',
    minWidth: 0,
  },
  nameBase: {
    minWidth: 0,
  },
  nameExtension: {
    flex: 'none',
  },
  removeButton: {
    '&.MuiIconButton-root': {
      flex: 'none',
      borderRadius: theme.shape.borderRadiusSm,
      color: theme.palette.text.secondary,
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  },
}));
